import Vue from "vue";
import VueApollo from "vue-apollo";
import { createApolloClient, restartWebsockets } from "vue-cli-plugin-apollo/graphql-client";
import jwtDecode from "jwt-decode";
Vue.use(VueApollo);

const AUTH_TOKEN = "COVID-apollo-token";

// eslint-disable-next-line no-undef
let env = _env;
const httpEndpoint = env.graphqlApi;
export const filesRoot = process.env.VUE_APP_FILES_ROOT || httpEndpoint.substr(0, httpEndpoint.indexOf("/graphql"));

Vue.prototype.$filesRoot = filesRoot;

const defaultOptions = {
  httpEndpoint,
  tokenName: AUTH_TOKEN,
  persisting: false,
  websocketsOnly: false,
  ssr: false,
};

export const { apolloClient, wsClient } = createApolloClient({
  ...defaultOptions,
});
export function createProvider() {
  apolloClient.wsClient = wsClient;
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        fetchPolicy: "cache-and-network",
      },
    },
    errorHandler(error) {
      // eslint-disable-next-line no-console
      console.log("%cError", "background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;", error.message);
    },
  });

  return apolloProvider;
}

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
  if (typeof localStorage !== "undefined" && token) {
    localStorage.setItem(AUTH_TOKEN, token);
    // if (localStorage.highestCompanyName !== highestCompanyName) {
    //   localStorage.loginCompany = highestCompanyName;
    // }
    // localStorage.highestCompanyName = highestCompanyName;
    // if (
    //   localStorage.getItem("loginCompany") === "null" ||
    //   localStorage.getItem("loginCompany") === null
    // ) {
    //   localStorage.loginCompany = highestCompanyName;
    // }
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("%cError on cache reset (login)", "color: orange;", e.message);
  }
}

export async function onRefreshToken(apolloClient, token, loginCompany) {
  if (typeof localStorage !== "undefined" && token) {
    localStorage.setItem(AUTH_TOKEN, token);
    localStorage.setItem("loginCompany", loginCompany);
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("%cError on cache reset (login)", "color: orange;", e.message);
  }
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  if (typeof localStorage !== "undefined") {
    localStorage.removeItem(AUTH_TOKEN);
  }
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient);
  try {
    await apolloClient.resetStore();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log("%cError on cache reset (logout)", "color: orange;", e.message);
  }
}

export function jwtDecoded() {
  let returnVal = {};
  if (typeof localStorage !== "undefined") {
    let data = localStorage.getItem(AUTH_TOKEN);
    returnVal = jwtDecode(data);
  }
  return returnVal;
}
